import { useState } from 'react'
import { Menu, X } from 'lucide-react'

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/80 backdrop-blur-md z-50 border-b border-apple-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="#" className="text-xl font-semibold text-apple-gray-900 tracking-tight">
              EcoBag Pro
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-apple-gray-700 hover:text-apple-gray-900 transition-colors text-sm">
              Home
            </a>
            <a href="#about" className="text-apple-gray-700 hover:text-apple-gray-900 transition-colors text-sm">
              About
            </a>
            <a href="#products" className="text-apple-gray-700 hover:text-apple-gray-900 transition-colors text-sm">
              Products
            </a>
            <a href="#quote" className="text-apple-gray-700 hover:text-apple-gray-900 transition-colors text-sm">
              Get Quote
            </a>
            <a href="#blog" className="text-apple-gray-700 hover:text-apple-gray-900 transition-colors text-sm">
              Blog
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-apple-gray-700 hover:text-apple-gray-900"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-apple-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="#home" className="text-apple-gray-700 hover:text-apple-gray-900 text-sm">Home</a>
              <a href="#about" className="text-apple-gray-700 hover:text-apple-gray-900 text-sm">About</a>
              <a href="#products" className="text-apple-gray-700 hover:text-apple-gray-900 text-sm">Products</a>
              <a href="#quote" className="text-apple-gray-700 hover:text-apple-gray-900 text-sm">Get Quote</a>
              <a href="#blog" className="text-apple-gray-700 hover:text-apple-gray-900 text-sm">Blog</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar
